import { render, staticRenderFns } from "./MatterCustomsRegistrationRenewalForm.vue?vue&type=template&id=970e0c58&"
import script from "./MatterCustomsRegistrationRenewalForm.vue?vue&type=script&lang=js&"
export * from "./MatterCustomsRegistrationRenewalForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterCustomsRegistrationRenewalForm.vue?vue&type=style&index=0&id=970e0c58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports